// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { CreditNote, LineItem, Order, OrderLineItem } = initSchema(schema);

export {
  CreditNote,
  LineItem,
  Order,
  OrderLineItem
};